import _pick from 'lodash/pick';
import { getGlobalProps } from '../utils/queryHelpers';

const FIELDS = [
  'id',
  'orgId',
  'label',
  'description',
  'customFieldTypeId',
  'customFieldRequirementLevelId',
  'customFieldVisibilityId',
  'listItems',
  'rowVersion',
  'customFieldSetTypeId',
  'displayOrder',
  'maxResponses'
];

const ShipmentReference = () => {
  const {
    orgInfo: { orgId }
  } = getGlobalProps();

  return {
    id: null,
    label: null,
    description: null,
    customFieldTypeId: null,
    customFieldRequirementLevelId: 'NONE',
    customFieldVisibilityId: 'SELECT',
    displayOrder: '1',
    maxResponses: '1',
    orgId,
    listItems: [],
    customFieldSetTypeId: 'SHIPMENT_REFERENCE',
    isNew: true
  };
};

export const sanitize = values => {
  const { id, rowVersion, orgId, ...initialValues } = _pick(values, FIELDS);
  if (!values.isNew) {
    return {
      ...initialValues,
      customFieldId: id,
      rowVersion
    };
  }
  return {
    ...initialValues,
    orgId
  };
};

export default ShipmentReference;
